import { qs, add } from "@fluorescent/dom";

// eslint-disable-next-line valid-jsdoc
/**
 * A complex image reveal animation with mask and scale transition.
 * @param {Object} node the target element for the animation
 * @param {Object} options optional default overrides
 * @options {Number} duration override the default duration
 */
export class ImageReveal {
  constructor(node, options = {}) {
    this.node = node;
    this.type = "ImageReveal";

    this.defaultOpts = {
      duration: window.theme.animation.duration,
    };
    this.config = { ...this.defaultOpts, ...options };

    this.imageEndY = "0%";

    this.imageReveal = qs(".image__reveal-container", this.node);
    this.img = qs(".image__img", this.node);

    this.gsapImport = import(flu.chunks.gsap).then(({ gsap, CustomEase }) => {
      gsap.registerPlugin(CustomEase);
      this.imageEase = gsap.parseEase(window.theme.animation.ease);

      gsap.set(this.imageReveal, { y: "100%" });
      gsap.set(this.img, { y: "-100%", scale: 1.75 });

      add(this.node, "animation-initialized");

      return { gsap };
    });
  }

  play(delay) {
    this.gsapImport.then(({ gsap }) => {
      gsap.to(this.imageReveal, {
        y: "0%",
        duration: this.config.duration,
        delay: delay,
        ease: this.imageEase,
      });
      gsap.to(this.img, {
        y: 0,
        duration: this.config.duration,
        delay: delay,
        ease: this.imageEase,
      });
      gsap.to(this.img, {
        scale: 1,
        duration: this.config.duration + this.config.duration / 2,
        delay: delay,
        ease: this.imageEase,
      });
    });
  }
}
